<template>
  <!-- Enabled when we have enough params, otherwise a disabled-looking span -->
  <router-link
      v-if="hasRequired"
      :to="to"
      target="_blank"
  >
    <slot>View notes</slot>
  </router-link>
  <span v-else><slot>View notes</slot></span>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'NotesDrillDownLink',
  props: {
    // 'notes-user' | 'notes-global'
    mode: { type: String, required: true },

    // From criteria bar slot
    params: { type: Object, required: true },

    // Normalized query from criteria bar
    query: { type: Object, default: () => ({}) },

    // Frontend route names
    routeNameUser:   { type: String, default: 'reports_notestats_user_notes_detailed' },
    routeNameGlobal: { type: String, default: 'reports_notestats_global_notes_detailed' },

    // Path date format used by your routes
    datePathFormat: { type: String, default: 'dd-LL-yyyy' },
  },

  computed: {
    routeName() {
      return this.mode === 'notes-user' ? this.routeNameUser : this.routeNameGlobal;
    },
    side() {
      const s = (this.params?.side || 'combined').toLowerCase();
      return ['sales', 'service', 'combined'].includes(s) ? s : 'combined';
    },
    userId() {
      return this.params && this.params.userId != null
          ? String(this.params.userId)
          : null;
    },
    hasRequired() {
      if (this.mode === 'notes-user') {
        return !!(this.params?.start && this.params?.end && this.userId);
      }
      return !!(this.params?.start && this.params?.end);
    },
    to() {
      if (this.mode === 'notes-user') {
        console.log(this.params);
        return {
          name: this.routeName,
          params: {
            userid: this.userId,
            type: this.side,
            start: this.pathDate(this.params.start),
            end:   this.pathDate(this.params.end),
          },
          query: this.sanitizedQuery,
        };
      }
      return {
        name: this.routeName,
        params: {
          type: this.side,
          start: this.pathDate(this.params.start),
          end:   this.pathDate(this.params.end),
        },
        query: this.sanitizedQuery,
      };
    },
    sanitizedQuery() {
      const base = (this.$route && this.$route.query) ? { ...this.$route.query } : {};
      const raw = { ...base, ...(this.query || {}) };
      const allowed = ['mask', 'match', 'not', 'includeOther', 'windowed', 'perPage', 'limit', 'per_page'];
      const out = {};
      for (const k of allowed) {
        const v = raw[k];
        if (v !== undefined && v !== null && String(v) !== '') out[k] = v;
      }
      if (out.includeOther !== undefined) out.includeOther = this.bool01(out.includeOther);
      if (out.windowed     !== undefined) out.windowed     = this.bool01(out.windowed);
      delete out.page;
      return out;
    },
  },

  methods: {
    pathDate(text) {
      let dt = DateTime.fromISO(String(text));
      if (!dt.isValid) dt = DateTime.fromFormat(String(text), 'yyyy-LL-dd HH:mm:ss');
      if (!dt.isValid) dt = DateTime.fromFormat(String(text), 'dd-LL-yyyy');
      if (!dt.isValid) dt = DateTime.local();
      return dt.toFormat(this.datePathFormat);
    },
    bool01(v) {
      if (typeof v === 'boolean') return v ? '1' : '0';
      const s = String(v).toLowerCase();
      if (['1','true','yes','on'].includes(s)) return '1';
      if (['0','false','no','off'].includes(s)) return '0';
      return s;
    },
  },
};
</script>
